import { Game } from "entities/game/types";
import { PageModuleData } from "entities/pages/types";
import { Dispatch, SetStateAction } from "react";

export type ModuleDetailsType = {
  allGames: Game[];
  brandId: string;
  pageId: string;
  moduleId: string | null;
  moduleData: PageModuleData | null;
  isLoadingSelectedGamesList: boolean;
  isFetchingSelectedGamesList: boolean;
  isLoadingAvailableStudios: boolean;
  availableStudios: { id: number; name: string }[] | undefined;
  handleDrawerClose: () => void;
  selectedTab: ModuleDetailsTabs;
  setSelectedTab: Dispatch<SetStateAction<ModuleDetailsTabs>>;
  threeCardsLoadingQueries: Record<number, boolean>;
  oneCardsLoadingQueries: Record<number, boolean>;
  topPrivacyTipsBlockImageLoadingQuery: boolean;
};

export enum ModuleDetailsTabs {
  General = "General",
  Tags = "Tags",
  SelectedGames = "SelectedGames",
  StudioOrdering = "StudioOrdering",
  Studios = "Studios",
  Translations = "Translations",
}

export enum ManagedTranslations {
  ModuleName = "Module name",
  CardTitle = "Card title",
  CardDescription = "Card description",
  ModuleTitle = "Module title",
  ModuleDescription = "Module description",
  CTAForRegisteredUser = "CTA for registered user",
  CTAForUnauthenticatedUser = "CTA for unregistered user",
}
